import { render } from "./LoginScreen.vue?vue&type=template&id=28f5bbcc"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__